import api from '../config/api';

class PackageService {
  constructor() {
    this.packageTypes = {
      beach: {
        keywords: ['beach', 'tropical', 'island', 'resort', 'caribbean', 'maldives', 'bali', 'hawaii', 'cancun', 'phuket'],
        activities: ['snorkeling', 'diving', 'beach', 'resort', 'spa', 'water sports'],
        duration: 7
      },
      adventure: {
        keywords: ['mountain', 'hiking', 'trekking', 'adventure', 'outdoor', 'national park', 'patagonia', 'nepal', 'new zealand'],
        activities: ['hiking', 'trekking', 'adventure', 'outdoor', 'climbing', 'camping'],
        duration: 10
      },
      city: {
        keywords: ['city', 'urban', 'metropolitan', 'cultural', 'museums', 'paris', 'london', 'tokyo', 'new york'],
        activities: ['museums', 'city tours', 'cultural', 'shopping', 'restaurants'],
        duration: 5
      },
      cultural: {
        keywords: ['cultural', 'historical', 'ancient', 'heritage', 'rome', 'athens', 'cairo', 'kyoto'],
        activities: ['historical tours', 'museums', 'cultural', 'heritage', 'ancient sites'],
        duration: 8
      }
    };
  }

  /**
   * Create vacation packages by combining flights, hotels, and activities
   * NOTE: This method is deprecated - packages are now created on the backend
   * @param {Object} params - Package parameters
   * @returns {Promise<Object>} Vacation package with combined pricing
   */
  async createVacationPackage(params) {
    console.warn('⚠️ createVacationPackage is deprecated - use backend API instead');
    throw new Error('createVacationPackage is deprecated - use backend API instead');
  }

  /**
   * Calculate package pricing by combining flight, hotel, and activity costs
   * NOTE: This method is deprecated - pricing is now calculated on the backend
   */
  calculatePackagePricing(recommendations, passengers, packageType) {
    console.warn('⚠️ calculatePackagePricing is deprecated - use backend API instead');
    return {
      flights: 0,
      hotels: 0,
      activities: 0,
      total: 0,
      savings: 0
    };
  }

  /**
   * Generate package description based on destination and type
   * NOTE: This method is deprecated - descriptions are now generated on the backend
   */
  generatePackageDescription(destination, packageType) {
    console.warn('⚠️ generatePackageDescription is deprecated - use backend API instead');
    return `Package to ${destination}`;
  }

  /**
   * Generate package highlights based on recommendations
   * NOTE: This method is deprecated - highlights are now generated on the backend
   */
  generatePackageHighlights(recommendations, packageType) {
    console.warn('⚠️ generatePackageHighlights is deprecated - use backend API instead');
    return ['Package highlights'];
  }

  /**
   * Get included items based on package type
   * NOTE: This method is deprecated - included items are now generated on the backend
   */
  getIncludedItems(packageType) {
    console.warn('⚠️ getIncludedItems is deprecated - use backend API instead');
    return ['Package items'];
  }

  /**
   * Get popular vacation packages from backend API (with caching)
   * @param {string} origin - Origin airport code (default: 'LAX')
   * @param {number} limit - Maximum number of packages to return
   * @returns {Promise<Array>} Array of vacation packages
   */
  async getPopularPackages(origin = 'LAX', limit = 10) {
    try {
      const { data } = await api.get(`/packages/popular`, {
        params: { origin, limit }
      });
      
      return data.packages;
      
    } catch (error) {
      console.error('❌ Frontend: Error fetching popular packages:', error);
      throw error;
    }
  }

  /**
   * Search for packages by destination and type (calls backend API)
   * @param {Object} params - Search parameters
   * @returns {Promise<Object>} Package data
   */
  async searchPackages(params) {
    try {
      const { data } = await api.get(`/packages/search`, { params });
      
      return data.packages;
      
    } catch (error) {
      console.error('❌ Frontend: Error searching packages:', error);
      throw error;
    }
  }

  /**
   * Get available package types
   * @returns {Promise<Array>} Array of package types
   */
  async getPackageTypes() {
    try {
      const { data } = await api.get(`/packages/types`);
      return data.types;
    } catch (error) {
      console.error('❌ Frontend: Error fetching package types:', error);
      throw error;
    }
  }
}

const packageService = new PackageService();
export default packageService;
